import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, input, output } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { ValueNameComponent } from '@app/shared/components';
import { ItemSelection } from '@app/dialogs';

@Component({
    selector: 'app-module-item-list',
    templateUrl: './item-list.component.html',
    styleUrls: ['./item-list.component.css'],
    imports: [TranslateModule, ButtonModule, TagModule, CdkDropList, CdkDrag, ValueNameComponent, TitleCasePipe],
})
export class ItemListComponent {
    readonly items = input.required<ItemSelection[]>();
    readonly testId = input.required<string>();

    readonly add = output<void>();
    readonly remove = output<ItemSelection>();
    readonly reorder = output<ItemSelection[]>();

    moveItem(index: number, direction: -1 | 1): void {
        const items = [...this.items()];
        moveItemInArray(items, index, index + direction);
        this.reorder.emit(items);
    }

    onDrop(event: CdkDragDrop<ItemSelection[]>): void {
        const items = [...this.items()];
        moveItemInArray(items, event.previousIndex, event.currentIndex);
        this.reorder.emit(items);
    }
}
